exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n    --klassapp-300: #f26948;\n    --klassapp-250: #ff6a47;\n    --klassapp-200: #f4876c;\n    --klassapp-100: #f9c3b5;\n    --klassapp-10: #fce7e1;\n    --klassapp-1: #fef9f7;\n    --whitebase: #fff;\n}\n", ""]);

// exports
